import { IServerResponse } from "app/interface";

export interface CostTrackerState {
    costTrackersList: Array<any>;
    costTrackersByFieldList: Array<any>;
    costTrackersById: any;
    connectorAndCommodityInfo: any;
    cloudProvidersList: Array<any>;
    eventsForTracker: Array<any>;
    eventInfo: any;
    saveEventResp: any;
    saveCostTrackerResp: IServerResponse;
    deleteCostTrackerResp: IServerResponse;
    costTrackerContracts: Array<any>;
}

export const initialState: CostTrackerState = {
    costTrackersList: null,
    costTrackersByFieldList: null,
    costTrackersById: {},
    connectorAndCommodityInfo: {},
    cloudProvidersList: [],
    eventsForTracker: [],
    eventInfo: null,
    saveEventResp: null,
    saveCostTrackerResp: null,
    deleteCostTrackerResp: null,
    costTrackerContracts: null
}
